import { schema } from 'normalizr'

// Circular Dependencies - Use the define method
// const item = new schema.Entity('item')
// const child = new schema.Entity('child')
// item.define({ children: [child] })

// Define Entities
// START ENTITY DEFINITIONS
const activity = new schema.Entity('activities')
const agency = new schema.Entity('agencies')
const artwork = new schema.Entity('artworks')
const artworkPage = new schema.Entity('artworkPages')
const attachment = new schema.Entity('attachments')
const brand = new schema.Entity('brands')
const brandTheme = new schema.Entity('brandThemes')
const campaign = new schema.Entity('campaigns')
const chartData = new schema.Entity('chartData')
const comment = new schema.Entity('comments')
const conversation = new schema.Entity('conversations')
const image = new schema.Entity('images')
const layoutTemplate = new schema.Entity('layoutTemplates')
const orderItem = new schema.Entity('orderItems')
const order = new schema.Entity('orders')
const provider = new schema.Entity('providers')
const publication = new schema.Entity('publications')
const publicationProduct = new schema.Entity('publicationProducts')
const relatedEntity = new schema.Entity('relatedEntities')
const role = new schema.Entity('roles')
const service = new schema.Entity('services')
const serviceProduct = new schema.Entity('serviceProducts')
const status = new schema.Entity('statuses')
const subscriber = new schema.Entity('subscribers')
const taskList = new schema.Entity('taskLists')
const taskListItem = new schema.Entity('taskListItems')
const taskListSection = new schema.Entity('taskListSections')
const taskListTemplate = new schema.Entity('taskListTemplates')
const taskListTemplateItem = new schema.Entity('taskListTemplateItems')
const taskListTemplateSection = new schema.Entity('taskListTemplateSections')
const tag = new schema.Entity('tags')
const team = new schema.Entity('teams')
const teamMember = new schema.Entity('teamMembers')
const templateGroup = new schema.Entity('templateGroups')
const templatePage = new schema.Entity('templatePages')
const templatePagePartial = new schema.Entity('templatePagePartials')
const trackingLink = new schema.Entity('trackingLinks')
const user = new schema.Entity('users')
// END ENTITY DEFINITIONS

artwork.define({
  order,
  campaign,
})

comment.define({
  user,
})

conversation.define({
  comments: [comment],
  subscribers: [subscriber],
})

relatedEntity.define({
  artwork_page: artworkPage,
  campaign,
  provider,
  service_product: serviceProduct,
  task_list_item: taskListItem,
  template_page: templatePage,
  user,
})

taskList.define({
  brand,
  related_entities: [relatedEntity],
  items: [taskListItem],
  sections: [taskListSection],
})

taskListItem.define({
  assignee: user,
  checklist_template: taskListTemplate,
  parent_task: taskListItem,
  related_entities: [relatedEntity],
  status,
  task_list: taskList,
  task_list_section: taskListSection,
  user,
})

taskListSection.define({
  items: [taskListItem],
})

taskListTemplate.define({
  items: [taskListTemplateItem],
  sections: [taskListTemplateSection],
})

tag.define({
  brand,
})

team.define({
  team_members: [teamMember],
})

teamMember.define({
  user,
})

templateGroup.define({
  brand,
  task_lists: [taskList],
})

templatePage.define({
  related_entities_where_subject: [relatedEntity],
})

templatePagePartial.define({
  brand,
})

order.define({
  items: [orderItem],
})

user.define({
  image,
  role,
})

// Export Schemas
export const Schemas = {
// START SCHEMA DEFINITION
  ACTIVITY: activity,
  ACTIVITY_ARRAY: [activity],
  AGENCY: agency,
  AGENCY_ARRAY: [agency],
  ARTWORK_PAGE: artworkPage,
  ARTWORK_PAGE_ARRAY: [artworkPage],
  ARTWORK: artwork,
  ARTWORK_ARRAY: [artwork],
  ATTACHMENT: attachment,
  ATTACHMENT_ARRAY: [attachment],
  BRAND: brand,
  BRAND_ARRAY: [brand],
  BRAND_THEME: brandTheme,
  BRAND_THEME_ARRAY: [brandTheme],
  CAMPAIGN: campaign,
  CAMPAIGN_ARRAY: [campaign],
  CHART_DATA: chartData,
  COMMENT: comment,
  COMMENT_ARRAY: [comment],
  CONVERSATION: conversation,
  CONVERSATION_ARRAY: [conversation],
  IMAGE: image,
  IMAGE_ARRAY: [image],
  LAYOUT_TEMPLATE: layoutTemplate,
  LAYOUT_TEMPLATE_ARRAY: [layoutTemplate],
  ORDER_ITEM: orderItem,
  ORDER_ITEM_ARRAY: [orderItem],
  ORDER: order,
  ORDER_ARRAY: [order],
  PROVIDER: provider,
  PROVIDER_ARRAY: [provider],
  PUBLICATION: publication,
  PUBLICATION_ARRAY: [publication],
  PUBLICATION_PRODUCT: publicationProduct,
  PUBLICATION_PRODUCT_ARRAY: [publicationProduct],
  RELATED_ENTITY_ARRAY: [relatedEntity],
  RELATED_ENTITY: relatedEntity,
  ROLE_ARRAY: [role],
  ROLE: role,
  SERVICE_ARRAY: [service],
  SERVICE_PRODUCT_ARRAY: [serviceProduct],
  SERVICE_PRODUCT: serviceProduct,
  SERVICE: service,
  STATUS_ARRAY: [status],
  STATUS: status,
  TASK_LIST: taskList,
  TASK_LIST_ARRAY: [taskList],
  TASK_LIST_ITEM: taskListItem,
  TASK_LIST_ITEM_ARRAY: [taskListItem],
  TASK_LIST_SECTION: taskListSection,
  TASK_LIST_SECTION_ARRAY: [taskListSection],
  TASK_LIST_TEMPLATE: taskListTemplate,
  TASK_LIST_TEMPLATE_ARRAY: [taskListTemplate],
  TASK_LIST_TEMPLATE_ITEM: taskListTemplateItem,
  TASK_LIST_TEMPLATE_ITEM_ARRAY: [taskListTemplateItem],
  TAG: tag,
  TAG_ARRAY: [tag],
  TEAM: team,
  TEAM_ARRAY: [team],
  TEAM_MEMBER: teamMember,
  TEAM_MEMBER_ARRAY: [teamMember],
  TEMPLATE_GROUP: templateGroup,
  TEMPLATE_GROUP_ARRAY: [templateGroup],
  TEMPLATE_PAGE: templatePage,
  TEMPLATE_PAGE_ARRAY: [templatePage],
  TEMPLATE_PAGE_PARTIAL: templatePagePartial,
  TEMPLATE_PAGE_PARTIAL_ARRAY: [templatePagePartial],
  TRACKING_LINK: trackingLink,
  TRACKING_LINK_ARRAY: [trackingLink],
  USER: user,
  USER_ARRAY: [user],
// END SCHEMA DEFINITION
}

export default Schemas
